import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track13EBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track13EBlue" transform="translate(1700.000000, 1141.000000)" className="track">
		<g id="line" transform="translate(0.000000, 28.038175)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M-1.11910481e-12,104.961825 C12.111538,112.744766 28.2391994,109.235744 36.02214,97.1242064 C36.6095193,96.2101474 37.1391757,95.2602588 37.6080098,94.2800993 L39.5962404,90.1234409 L39.5962404,90.1234409"/>

			<TrackArrow transform="translate(38.974079, 92.147703) rotate(-243.000000) translate(-38.974079, -92.147703) "
									points="42.9740792 100.147703 34.9740792 92.1477035 42.9740792 84.1477035"/>

			<line x1="44.7071632" y1="79.5927967" x2="88.0905989" y2="0.0645159801"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track13EBlue')}
			coords="41.972656, 60.066406"
			text="13E"
			textCoordsX={'8.04101562'}
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<line x1="165" y1="5" x2="89.0051882" y2="27.247754" id="line"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
					strokeWidth={tracksWidth}
					strokeLinecap="round"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track13EBlue')}
			coords="105.972656, 0.066406"
			text="13E"
			textCoordsX={'8.04101562'}
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track13EBlue.propTypes = trackPropTypes;

export default Track13EBlue;
